import { useSelector } from "react-redux";

import { DialogTitle, DialogContent, Typography, Grid, DialogActions, Button } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import constants from "../../../utils/constants";

export default function Confirmation(props) {
  const bookingStatus = useSelector((state) => state.booking.bookingStatus);

  return (
    <>
      <DialogTitle title="Thank You" />

      <DialogContent>
        <Grid container alignItems="center" columnSpacing={2}>
          <Grid item>
            <CheckCircleIcon sx={{ color: "green", fontSize: 50 }} />
          </Grid>
          <Grid item xs>
            <Typography variant="body1" gutterBottom>
              Thank you for booking your appointment with Litco Law! You will receive a confirmation email soon.
            </Typography>
            {bookingStatus === constants.BOOKING_STATUS.COMPLETE_EXTRA_OCCUPANTS && (
              <Typography variant="body1" gutterBottom>
                Occupants under the age of 18 do not need to attend the meeting.
              </Typography>
            )}
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button variant="contained" onClick={props.onClose}>
          Close
        </Button>
      </DialogActions>
    </>
  );
}
